import { render, staticRenderFns } from "./SubcontractorAverageRatingCard.vue?vue&type=template&id=5b5b3754"
import script from "./SubcontractorAverageRatingCard.vue?vue&type=script&lang=ts"
export * from "./SubcontractorAverageRatingCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports